import styled from 'styled-components';

/* Design bands are max-width, not the theme's min-width set. */
const abp = (key: string) => (props: any) => props.theme.awarenessBreakpoints && props.theme.awarenessBreakpoints[key];

const FormWrapper = styled.div`
    width: 100%;
`;

// First and last name sit side by side on larger screens. Row gap is 0 because
// each Field already carries its own margin-bottom, so the fields stack with
// normal field spacing on mobile instead of gap + margin stacking together.
const NameRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    row-gap: 0;

    @media screen and (max-width: ${abp('w820')}) {
        grid-template-columns: 1fr;
    }
`;

const Field = styled.div`
    margin-bottom: 20px;

    input {
        width: 100%;
        height: 48px;
        border: solid 1px #808080;
        border-radius: 12px;
        padding: 0 16px;
        font-family: Overpass;
        font-size: 16px;
        line-height: 24px;
        box-sizing: border-box;
    }
`;

const FieldLabel = styled.label`
    display: block;
    margin-bottom: 6px;
    font-family: Overpass;
    font-weight: 300;
    font-size: 16px;
    line-height: 28px;
    color: #161719;
`;

// Error text shown under a field, such as Invalid email address.
const FieldError = styled.p`
    margin: 6px 0 0;
    font-family: Overpass;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #D93A3F;
`;

const ConsentRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 10px 0 4px;

    input[type='checkbox'] {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        margin-top: 2px;
        accent-color: #000;
    }
`;

const ConsentCheckbox = styled.div`
    flex-shrink: 0;
`;

const ConsentLabel = styled.div`
    font-family: Overpass;
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
    color: #161719;

    p {
        margin: 0;
        font: inherit;
        color: inherit;
    }

    a {
        color: #161719;
        text-decoration: underline;
    }
`;

// Sign up button sits between the first and remaining checkboxes.
const ButtonRow = styled.div`
    margin: 12px 0 24px;
    width: 267px;
    max-width: 100%;

    && a {
        display: inline-flex;
        width: 100%;
        height: 48px;
        min-height: 48px;
        justify-content: center;
        box-sizing: border-box;
        font-weight: 600;

        span {
            font-weight: 600;
        }
    }
`;

const ErrorText = styled.div<{ isShown: boolean }>`
    display: ${props => (props.isShown ? 'block' : 'none')};
    margin-top: 8px;
    color: #D93A3F;
    font-family: Overpass;
    font-size: 14px;
    line-height: 20px;
`;

export {
    FormWrapper,
    NameRow,
    Field,
    FieldLabel,
    FieldError,
    ConsentRow,
    ConsentCheckbox,
    ConsentLabel,
    ButtonRow,
    ErrorText,
};
